import {TextField, Autocomplete, Paper, Popper} from "@mui/material";

interface CustomSelectProps <T extends { value: string | number; label: string }> {
  items: T[];
  inputLabel?: string;
  selectAllOption?: boolean;
  onChange?: (event: React.SyntheticEvent, value: (string | number)[]) => void;
  value: T | null;
  setValue: (value: T | null) => void;
  selectAllInitially? : boolean;
  is_disabled?:boolean;
  is_required?:boolean;
  sx?;
}

const customPopper = (props) => {
  return (
    <Popper {...props}
            placement="bottom"
            sx={{ height: "10px", }}
            style={{ width: props.anchorEl.clientWidth, height: "5px" }} />
  )
};


const SearchableSelect = <T extends { value: string | number; label: string }>({
  items,
  inputLabel = "",
  value ,  // State lifted from parent
  setValue, // Function to update state in the parent
  is_disabled=false,
  is_required=false,
  sx = {}
} : CustomSelectProps<T>) => {

  return (
    <Autocomplete
      options={items}
      value={value}
      onChange={(_e, newValue) => {setValue(newValue);}}
      isOptionEqualToValue={(option, value) => option.value === value?.value}
      sx={{
        '& .MuiInputLabel-root': {
          color: 'var(--font-primary) !important', // Color of the label
        },
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: 'var(--naturGreen)', // Green border
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: 'var(--naturGreen)', // Green border on hover
        },
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: 'var(--naturGreen)', // Green border on focus
        },
        ...sx
      }}
      getOptionLabel={(option) => option.label}
      renderOption={(props, option, { selected }) => {
         return (<li {...props}
                    key={option.value}
                    style={{
                      transition: 'background-color 0.15s ease-in-out',
                      backgroundColor: selected ? 'var(--naturGreen)' : 'transparent',
                      color: selected ? 'var(--font-primary)' : 'inherit',
                      cursor: 'pointer',
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = 'var(--primary-color)')}
                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = selected ? 'var(--naturGreen)' : 'transparent')}>
          {option.label}
        </li>);
      }}
      renderInput={(params) => <TextField {...params} label={inputLabel + (is_required ? "*" : "")}/>}
      PaperComponent={(paperProps) => (<Paper {...paperProps} />)}
      PopperComponent={customPopper}
      disabled={is_disabled}
    />
  );
};

export default SearchableSelect;